export default {
  'alert/delete/record': 'Tem certeza que deseja excluir este registro?',
  'alert/delete/document': 'Tem certeza de que deseja excluir este documento?',
  'alert/delete/prescription': 'Tem certeza de que deseja excluir esta prescrição?',
  'alert/delete/exam': 'Tem certeza de que deseja excluir este pedido de exames?',
  'alert/delete/appointment': 'Tem certeza que deseja excluir este agendamento?',
  'alert/delete/recurrent_appointments': 'Tem certeza que deseja excluir esta consulta e as próximas da série?',
  'alert/delete/recurrent_blocked': 'Tem certeza que deseja excluir este horário e os próximos da série?',
  'alert/delete/service': 'Tem certeza que deseja excluir este serviço?',
  'alert/delete/payment': 'Tem certeza que deseja excluir este pagamento?',
  'alert/delete/receipt': 'Tem certeza que deseja excluir este recibo?',
  'alert/delete/service_template': 'Tem certeza que deseja excluir este serviço da tabela?',
  'alert/hide/appointment': 'Deseja também remover esta consulta da agenda?',
  'alert/confirm_delete_file': 'Tem certeza que deseja apagar este arquivo?',
  'alert/confirm_delete_account': 'Tem certeza que deseja excluir a sua conta? Essa ação não pode ser desfeita.',
  'alert/confirm_delete_measure': 'Tem certeza que deseja apagar este indicador?',
  'alert/confirm_quit_form': 'Há alterações não salvas. Você quer sair sem salvar?',
  'alert/confirm_delete_form': 'Tem certeza de que deseja apagar este formulário?',
  'alert/secretaries/form/confirm': 'Deseja realmente excluir esta secretária?',
  'alert/delete_patient_question': 'Deseja realmente excluir este paciente?',
  'info/file_not_allowed': 'Arquivo não permitido.',
  'info/finalize_record_tip/print': 'Finalize sua consulta para habilitar a impressão.',
  'info/finalize_record_tip/change_date': 'Finalize sua consulta para alterar a data.',
  'info/finalize_record_tip/change_date/with_appointment': 'Você não pode alterar a data de consultas criadas na agenda.',
  'info/patient_needs_email': 'Este paciente não tem nenhum email cadastrado.',
  'error/invalid_recurrency_days': 'Selecione ao menos um dia.',
  'info/finalize_record_tip/blocked_edit': 'Finalize um registro em andamento para poder editar outro.',
  'error/mobile/file_not_downloadable': 'Este tipo só pode ser compartilhado pelo computador.',
  'error/browser_unavailable': 'Não foi possível abrir o navegador. Tente de novo em instantes.',
  'alert/google_calendar/disconnect': 'Desconectar o Google Agenda? O Doutore para de enviar suas consultas para o Google e de criar links do Google Meet.',
  'error/direct_share/email/not_present': 'Este paciente não tem um email cadastrado, deseja cadastrar um?',
  'error/direct_share/mobile_phone/not_present': 'Este paciente não tem número de celular cadastrado deseja cadastrar um?',
  'error/direct_share/birthdate/not_present': 'Este paciente não tem data de nascimento cadastrada, deseja cadastrar?',
  'button/direct_share/confirm_button/ok': 'Ir para o cadastro',
  'button/direct_share/confirm_button/cancel': 'Fazer depois',
  'alert/support_chat_unavailable': 'Não conseguimos abrir o chat agora. Quer falar com o suporte pelo WhatsApp?',
  'button/support_whatsapp': 'Abrir o WhatsApp',
  'button/support_not_now': 'Agora não',
  'alert/storage_save_failed': 'O Doutore não está conseguindo guardar os dados neste aparelho. Quer recarregar os dados agora?',
  'info/storage_full': 'Não há espaço livre neste aparelho para o Doutore guardar dados. Você pode continuar usando, mas libere espaço para evitar problemas ao abrir o Doutore.',
  'button/yes': 'Sim',
  'button/no': 'Não',
  'button/ok': 'Ok',
};
